<template>
  <div class="container">
    <div style="text-align: left; width: 100%;">
      <a-button
        @click="goDashboard"
        class="text-left mb-2"
        style="border-radius: 20px; background-image: linear-gradient(to right, #1D2671 , #830051); color: white;"
      >
        <LeftOutlined /> Back
      </a-button>
    </div>
    <a-input-search
      v-model:value="search"
      :placeholder="searchBy === 'name' ? 'Cari nama pasien' : 'Cari obat pasien'"
      enter-button
      style="margin: 16px 0"
    />

    <div style="margin-bottom: 8px">Cari berdasarkan</div>
    <a-radio-group v-model:value="searchBy" style="margin-bottom: 16px">
      <a-radio-button value="id">Obat</a-radio-button>
      <a-radio-button value="name">Nama</a-radio-button>
    </a-radio-group>

    <a-table
      :columns="columns"
      :data-source="filteredPatients"
      :pagination="{ pageSize: 10 }"
      row-key="id"
      @row-click="openDetailModal"
    >
      <template #status="{ record }">
        <span
          :style="{
            color:
              getPatientStatus(record) === 'Disetujui'
                ? '#52c41a' // Warna hijau untuk status baru
                : getPatientStatus(record) === 'Perpanjang'
                ? '#d4af00'
                : getPatientStatus(record) === 'Tidak Perpanjang'
                ? '#fa541c'
                : getPatientStatus(record) === 'Ditolak'
                ? '#f5222d'
                : '',
            fontWeight: 500,
          }"
        >
          {{ getPatientStatus(record) }}
        </span>
      </template>
    </a-table>

    <a-modal
      v-model:visible="visible"
      title="DETAIL & VERIFIKASI PASIEN"
      :footer="null"
      @cancel="handleModalClose"
    >
      <div class="doctor-detail-card">
        <h3>{{ selectedPatient?.patient.fullname }}</h3>
        <p style="color: #999; margin-top: -8px">{{ selectedPatient?.patient.city }}</p>
      </div>

      <div class="row doctor-detail-grid">
        <div class="col-6 mb-2" v-if="selectedPatient?.pharmacy"><strong>Apotek</strong><br /></div>
        <div class="col-6 mb-2" v-if="selectedPatient?.pharmacy">
          : {{ selectedPatient?.pharmacy.name }}
        </div>
        <div class="col-6 mb-2"><strong>Tanggal Pengajuan</strong><br /></div>
        <div class="col-6 mb-2">: {{ formatISODate(selectedPatient?.enrollDate) }}</div>
        <div class="col-6 mb-2" v-if="selectedPatient?.carryOverDate">
          <strong>Tanggal Scan</strong><br />
        </div>
        <div class="col-6 mb-2" v-if="selectedPatient?.carryOverDate">
          : {{ formatISODate(selectedPatient?.carryOverDate) }}
        </div>
        <div class="col-6 mb-2"><strong>No. KTP</strong><br /></div>
        <div class="col-6 mb-2">: {{ selectedPatient?.patient.idNumber }}</div>

        <div class="col-6 mb-2"><strong>Form Persetujuan</strong><br /></div>
        <div class="col-6 mb-2">
          <a
            v-if="selectedPatient?.patient.consent"
            href="#"
            @click.prevent="
              handleDownloadPdf(
                selectedPatient.patient.consent,
                `form-persetujuan-${selectedPatient.patient.fullname}.pdf`,
              )
            "
          >
            : Download Sekarang
          </a>
          <span v-else>: Tidak tersedia</span>
        </div>
        <div class="col-12 my-2" v-if="selectedPatient?.patient.consent">
          <iframe
            :src="`${baseUrl}${selectedPatient.patient.consent}`"
            style="width: 100%; height: 500px; border: 1px solid #e8e8e8; border-radius: 8px"
            title="Form Persetujuan Pasien"
          >
            Browser Anda tidak mendukung pratinjau PDF. Silakan unduh file untuk melihatnya.
          </iframe>
        </div>
        <div class="col-12 mb-2">
          <strong> Foto KTP :</strong>
        </div>

        <div class="col-12 my-2" v-if="selectedPatient?.patient.idPicture">
          <img
            :src="`${baseUrl}${selectedPatient?.patient.idPicture}`"
            alt="Foto KTP"
            class="modal-image my-2"
          />
        </div>
        <div class="col-12 my-2">
          <strong> Foto Selfie :</strong>
        </div>

        <div class="col-12 my-2" v-if="selectedPatient?.patient.selfiePicture">
          <img
            :src="`${baseUrl}${selectedPatient?.patient.selfiePicture}`"
            alt="Foto Selfie"
            class="modal-image my-2"
          />
        </div>
        <div class="col-6 mb-2"><strong>Email</strong><br /></div>
        <div class="col-6 mb-2">: {{ selectedPatient?.patient.email }}</div>
        <div class="col-6 mb-2"><strong>Telepon</strong><br /></div>
        <div class="col-6 mb-2">: {{ selectedPatient?.patient.representativePhone }}</div>
        <div class="col-6 mb-2"><strong>Nama Dokter</strong><br /></div>
        <div class="col-6 mb-2">: {{ selectedPatient?.doctor.fullname }}</div>
        <div class="col-12 my-2">
          <strong>Hasil Tes :</strong>
        </div>

        <div class="col-12 my-2" v-if="selectedPatient?.testLab && selectedPatient.testLab.testLabEvidences.length">
          <img
            :src="
              `${baseUrl}${
                selectedPatient?.testLab.testLabEvidences[
                  selectedPatient?.testLab.testLabEvidences.length - 1
                ].url
              }`
            "
            alt="Hasil Tes"
            class="modal-image my-2"
          />
        </div>
        <div class="col-6 mb-2"><strong>Nama Obat</strong><br /></div>
        <div class="col-6 mb-2">: {{ selectedPatient?.programType.name }}</div>
        <div class="col-6 mb-2" v-if="selectedPatient?.price">
          <strong>Jumlah Obat</strong><br />
        </div>
        <div class="col-6 mb-2" v-if="selectedPatient?.price">
          : {{ selectedPatient?.price.name }}
        </div>
        <div class="col-12 my-2">
          <strong>Resep :</strong>
        </div>

        <div class="col-12 my-2" v-if="selectedPatient?.programEvidences.length">
          <img
            :src="
              `${baseUrl}${
                selectedPatient?.programEvidences[selectedPatient?.programEvidences.length - 1].url
              }`
            "
            alt="Resep"
            class="modal-image my-2"
          />
        </div>
        <div
          class="col-12 mb-2"
          v-if="selectedPatient?.prevProgram && selectedPatient?.prevProgram.invoiceUrl"
        >
          <strong> Bukti Pembayaran :</strong>
        </div>

        <div
          class="col-12 my-2"
          v-if="selectedPatient?.prevProgram && selectedPatient?.prevProgram.invoiceUrl"
        >
          <img
            :src="`${baseUrl}${selectedPatient?.prevProgram.invoiceUrl}`"
            alt="Bukti Pembayaran"
            class="modal-image my-2"
          />
        </div>
        <div
          class="col-12 mb-2"
          v-if="selectedPatient?.prevProgram && selectedPatient?.prevProgram.ralanUrl"
        >
          <strong> Bukti Rawat Jalan :</strong>
        </div>

        <div
          class="col-12 my-2"
          v-if="selectedPatient?.prevProgram && selectedPatient?.prevProgram.ralanUrl"
        >
          <img
            :src="`${baseUrl}${selectedPatient?.prevProgram.ralanUrl}`"
            alt="Bukti Rawat Jalan"
            class="modal-image my-2"
          />
        </div>
        <div class="col-6 mb-2"><strong>ID Pasien</strong><br /></div>
        <div class="col-6 mb-2">: {{ selectedPatient?.patient.code }}</div>
        <div class="col-6 mb-2"><strong>Status Permintaan</strong><br /></div>
        <div class="col-6 mb-2">: {{ selectedPatient?.prevProgram ? 'Perpanjang' : 'Baru' }}</div>
      </div>

      <!-- <div v-if="selectedPatient?.checkPoint === 4">
        <div class="verification-form">
          <div class="form-item">
            <label>Verifikasi Apotek</label>
            <a-select
              v-model:value="selectedPharmacy"
              show-search
              placeholder="Cari dan pilih apotek"
              style="width: 100%"
              :filter-option="filterOption"
            >
              <a-select-option v-for="item in pharmacy" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>

          <div class="form-item">
            <label>Jumlah Obat</label>
            <a-select
              v-model:value="selectedPrice"
              placeholder="Pilih jumlah obat"
              style="width: 100%"
            >
              <a-select-option v-for="item in price" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>

        <div class="doctor-detail-actions">
          <a-button
            type="primary"
            @click="handleApprove"
            style="background: linear-gradient(to right, #f2994a, #f2c94c); border: none"
          >
            DISETUJUI
          </a-button>
          <a-button danger @click="handleReject"> TIDAK DISETUJUI </a-button>
        </div>
      </div> -->
    </a-modal>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { notification } from 'ant-design-vue'
import {
  getAllProgram,
  getAllProgramApproved,
  getFarmasi,
  getPrice,
  approveProgram,
} from '../../services/axios/pulih/index'
import { LeftOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'

export default {
  components: {
    LeftOutlined,
  },
  setup() {
    const router = useRouter()
    const search = ref('')
    const searchBy = ref('name')
    const statusFilter = ref('all')
    const visible = ref(false)
    const selectedPatient = ref(null)
    const patients = ref([])
    const pendingPatients = ref([])
    const userData = ref({})
    const baseUrl = ref('https://pulih-api-prod.digitala.id')

    // State untuk dropdowns di modal
    const pharmacy = ref([])
    const price = ref([])
    const selectedPharmacy = ref(null)
    const selectedPrice = ref(null)

    const columns = [
      { title: 'Code', dataIndex: ['patient', 'code'], key: 'code' },
      { title: 'Nama', dataIndex: ['patient', 'fullname'], key: 'name' },
      { title: 'Obat', dataIndex: ['programType', 'name'], key: 'obat' },
      { title: 'Tanggal Transaksi', dataIndex: ['tanggalTransaksi'], key: 'transaksi' },
    ]
    const goDashboard = () => {
      router.push('/farmasi')
    }
    const getPatientStatus = patient => {
      if (patient.isTerminated) {
        return 'Tidak Perpanjang'
      }

      if (patient.isApproved) {
        if (patient.prevProgram) {
          return 'Perpanjang'
        } else {
          return 'Disetujui'
        }
      }

      return 'Ditolak'
    }

    const filteredPatients = computed(() =>
      patients.value.filter(p => {
        const keyword = search.value.toLowerCase()
        const matchesSearch =
          searchBy.value === 'name'
            ? p.patient?.fullname
              ? p.patient?.fullname.toLowerCase().includes(keyword)
              : ''
            : p.programType?.name.toLowerCase().includes(keyword)

        const currentStatus = getPatientStatus(p)
        const matchesStatus = statusFilter.value === 'all' || currentStatus === statusFilter.value

        return matchesSearch && matchesStatus
      }),
    )
    const formatISODate = isoString => {
      if (!isoString) return ''
      const date = new Date(isoString)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}-${month}-${year}`
    }

    const formatPrice = priceItem => {
      const formattedAmount = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      }).format(priceItem.price)
      return `${priceItem.package} - ${formattedAmount}`
    }

    const filterOption = (input, option) => {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    const openDetailModal = patient => {
      console.log(patient, 'cekini')
      selectedPatient.value = patient
      visible.value = true
    }

    const handleModalClose = () => {
      visible.value = false
      selectedPharmacy.value = null
      selectedPrice.value = null
    }

    // =======================================================
    // ==== FUNGSI BARU UNTUK MENGUNDUH PDF ====
    // =======================================================
    const handleDownloadPdf = async (fileUrl, fileName) => {
      if (!fileUrl) return

      notification.info({
        message: 'Mengunduh...',
        description: `Mempersiapkan file ${fileName} untuk diunduh.`,
        duration: 2,
      })

      try {
        const fullUrl = `${baseUrl.value}${fileUrl}`
        const response = await fetch(fullUrl)
        if (!response.ok) {
          throw new Error('Gagal mengunduh file dari server.')
        }

        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Error saat mengunduh PDF:', error)
        notification.error({
          message: 'Gagal Mengunduh',
          description: 'Tidak dapat mengunduh file. Silakan coba lagi.',
        })
      }
    }

    const handleApprove = async () => {
      if (!selectedPharmacy.value || !selectedPrice.value) {
        notification.error({
          message: 'Validasi Gagal',
          description: 'Harap pilih Apotek dan Jumlah Obat terlebih dahulu.',
        })
        return
      }

      try {
        const payload = {
          id: selectedPatient.value.id,
          pharmacyId: selectedPharmacy.value,
          priceId: selectedPrice.value,
        }
        await approveProgram(payload)

        notification.success({
          message: 'Berhasil',
          description: `Pasien ${selectedPatient.value.patient.fullname} telah disetujui.`,
        })

        fetchData(userData.value.user.programId)
        handleModalClose()
      } catch (error) {
        notification.error({
          message: 'Gagal Approve',
          description: 'Terjadi kesalahan saat memproses persetujuan.',
        })
      }
    }

    const handleReject = () => {
      // console.log('Pasien ditolak:', selectedPatient.value.id)
      notification.info({
        message: 'Info',
        description: 'Proses penolakan pasien telah dicatat.',
      })
      handleModalClose()
    }

    const fetchData = async programId => {
      try {
        const dataPromise = getAllProgram(programId)
        const dataApprovedProgram = await getAllProgramApproved()
        console.log(dataApprovedProgram, 'cekiniapproved')
        const pricePromise = getPrice(programId)
        const pharmacyPromise = getFarmasi()

        const [data, priceData, pharmacyData] = await Promise.all([
          dataPromise,
          pricePromise,
          pharmacyPromise,
        ])

        price.value = priceData
        pharmacy.value = pharmacyData.data

        patients.value = dataApprovedProgram.map(e => {
          return {
            ...e,
            tanggalTransaksi: e.drugsTakenDate ? formatISODate(e.drugsTakenDate) : '',
          }
        })
      } catch (error) {
        console.error('Gagal mengambil data:', error)
        notification.error({
          message: 'Gagal Memuat Data',
          description: 'Tidak dapat mengambil data dari server. Silakan coba lagi nanti.',
        })
      }
    }

    onMounted(() => {
      const storedUserData = localStorage.getItem('userData')
      if (storedUserData) {
        userData.value = JSON.parse(storedUserData)
        fetchData(userData.value.user.programId)
      }
    })

    return {
      search,
      searchBy,
      statusFilter,
      visible,
      selectedPatient,
      patients,
      columns,
      pendingPatients,
      filteredPatients,
      pharmacy,
      price,
      selectedPharmacy,
      selectedPrice,
      getPatientStatus,
      formatPrice,
      filterOption,
      openDetailModal,
      handleModalClose,
      handleApprove,
      handleReject,
      baseUrl,
      formatISODate,
      handleDownloadPdf,
      goDashboard,
    }
  },
}
</script>

<style scoped>
.container {
  margin: 0 auto;
  background-color: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.card-scroll-wrapper {
  overflow-x: auto;
  margin-bottom: 16px;
}
.card-list {
  display: flex;
  gap: 16px;
  min-width: max-content;
}
.doctor-card {
  border: 2px solid #9b1c7b;
  border-radius: 12px;
  padding: 12px 16px;
  min-width: 240px;
  text-align: center;
  background: #fdfcff;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.doctor-card:hover {
  transform: translateY(-2px);
}
.doctor-detail-card {
  text-align: center;
  margin-bottom: 16px;
}
.doctor-detail-grid {
  margin-bottom: 16px;
}
.verification-form {
  margin-top: 16px;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}
.form-item {
  margin-bottom: 16px;
}
.form-item label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}
.doctor-detail-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
}
.modal-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: contain;
}
</style>
